import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import UsersTable from "../components/UsersTable";
import { ToastContainer } from 'react-toastify';

const UsersOwnersPage = () => {
  return (
    <MasterLayout>
      <ToastContainer />
      <Breadcrumb title="Owner Kullanıcılar" />
      <UsersTable role="owners" title="Owner Kullanıcılar" />
    </MasterLayout>
  );
};

export default UsersOwnersPage;

